import { apiRequest } from "./api";

export type CashAdvanceStatus = "PENDING" | "APPROVED" | "RELEASED" | "PAID" | "REJECTED";

export interface CashAdvance {
  cashAdvId: string;
  userId: string;
  businessId: string;
  employeeName?: string;
  amount: number;
  repaidAmount: number;
  remainingAmount: number;
  status: CashAdvanceStatus;
  requestedAt: string;
  reason?: string;
  approvedBy?: string;
  approvedAt?: string;
  releasedBy?: string;
  releasedAt?: string;
  releaseNote?: string;
  rejectedBy?: string;
  rejectedAt?: string;
  rejectedReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CashAdvanceLimit {
  biMonthlyCapacity: number;
  loanDeduction: number;
  outstandingCA: number;
  remainingCapacity: number;
}

export interface RequestCashAdvancePayload {
  businessId: string;
  amount: number;
  employeeName?: string;
  reason?: string;
}

export interface ApproveCashAdvancePayload {
  userId: string;
  businessId: string;
}

export interface ReleaseCashAdvancePayload {
  userId: string;
  businessId: string;
  releasedAt: string;
  releaseNote?: string;
}

export interface RejectCashAdvancePayload {
  userId: string;
  businessId: string;
  rejectedReason?: string;
}

export const cashAdvanceApi = {
  listMyCashAdvances: (status?: CashAdvanceStatus, params?: { limit?: number; cursor?: string; businessId?: string }) =>
    apiRequest<{ items: CashAdvance[]; nextCursor: string | null } & CashAdvanceLimit>("/me/cash-advances", {
      params: {
        ...(status ? { status } : {}),
        limit: params?.limit ?? 10,
        ...(params?.cursor ? { cursor: params.cursor } : {}),
        ...(params?.businessId ? { businessId: params.businessId } : {}),
      },
    }),

  requestCashAdvance: (payload: RequestCashAdvancePayload) =>
    apiRequest<CashAdvance>("/me/cash-advances", { method: "POST", body: payload }),

  adminListCashAdvances: (businessId: string, status: CashAdvanceStatus = "PENDING", limit = 50) =>
    apiRequest<{ items: CashAdvance[]; nextKey: string | null }>("/admin/cash-advances", {
      params: { businessId, status, limit },
    }),

  approveCashAdvance: (cashAdvId: string, payload: ApproveCashAdvancePayload) =>
    apiRequest<{ success: boolean }>(`/admin/cash-advances/${cashAdvId}/approve`, {
      method: "POST",
      body: payload,
    }),

  releaseCashAdvance: (cashAdvId: string, payload: ReleaseCashAdvancePayload) =>
    apiRequest<{ success: boolean }>(`/admin/cash-advances/${cashAdvId}/release`, {
      method: "POST",
      body: payload,
    }),

  rejectCashAdvance: (cashAdvId: string, payload: RejectCashAdvancePayload) =>
    apiRequest<{ success: boolean }>(`/admin/cash-advances/${cashAdvId}/reject`, {
      method: "POST",
      body: payload,
    }),
};
